import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button, TextField } from '@mui/material'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { updateNotic } from '../Store/ActionCreators/NotifactionActionCreator'
import { getCategory } from '../Store/ActionCreators/CategoryActionCreator';

export default function UpdateNotifaction() {
   const [data, setData] = useState({
          category : '',
          titlename : '',
          content : ""
      })
      const dispatch = useDispatch()
      const navigate = useNavigate()
      const noticList = useSelector((state)=> state.NoticStateData)
      const categoryList = useSelector((state)=>state.CategoryStateData)
      const {_id} = useParams()
      function getData(e){
          const name = e.target.name
          const value = e.target.value
          setData((old)=>{
              return{
                  ...old,
                  [name]: value
              }
          })
      }
      function postData(e){
          e.preventDefault()
          const item = {
              _id : _id,
              category : data.category,
              titlename : data.titlename,
              content:data.content
          }
          dispatch(updateNotic(item))
          navigate("/notifaction")
      }
        useEffect(()=>{
          dispatch(getCategory())
        },[dispatch])

      useEffect(()=>{
          const foundData = noticList.find((item) => item._id === _id);
          if (foundData) {
              setData(foundData);
          }   
    }, [noticList, _id]);
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box className="boxStyle">
        <h4 className='bg-dark text-light p-1 text-center rounded mt-2'>Update Natifaction</h4>
        <div className="formSection">
          <h5>Update Notifaction Form</h5>
          <form className='mt-3' onSubmit={postData}>
            <div className="mb-3">
               <FormControl fullWidth>
                  <InputLabel id="select-subject">Select&nbsp;Subject</InputLabel>
                      <Select
                        labelId="select-subject"
                          id="demo-simple-select"
                          label="Select Subject"
                          name='category'
                          onChange={getData}
                          color='success'
                          variant='outlined' 
                          value={data.category}
                      >
                        <MenuItem selected>Select Category</MenuItem>s
                          {
                            categoryList.map((cat, index) => (
                              <MenuItem value={cat.name} key={index}>{cat.name}</MenuItem>
                            ))
                          }                                      
                      </Select>
                </FormControl>
            </div>
            <div className="mb-3">
              <TextField placeholder='Enter Notifaction Header Name' name='titlename' variant='outlined' label="Notifaction Name" fullWidth color='success' onChange={getData} value={data.titlename}/>
            </div>
            <div className="mb-3">
              <TextField
                label="Full Notice Content (HTML Allowed)"
                multiline
                rows={10}
                fullWidth
                placeholder="Yahan full notice details likho ya HTML paste karo"
                value={data.content}
                onChange={getData}
              />
            </div>

            <div className="mb-3 mt-5">
              <Button type='submit' className='bg-dark text-light w-100 p-2'>Add Notifaction</Button>
            </div>
          </form>
        </div>
      </Box>
    </Box>
  )
}
